module.exports = __webpack_public_path__ + "static/media/04.a9a81d13.png";